'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mtopFetch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileOverview
                                                                                                                                                                                                                                                                               * @author Donny
                                                                                                                                                                                                                                                                               */

// lib


require('@ali/lib-mtop');

/**
 * 检查mtop返回值
 * @return {Boolen}               [返回值是否可用]
 */
var validateMtopResponse = function validateMtopResponse(response) {
  return response.code * 1 === 0;
};

/**
 * 线上域名白名单
 */
var DOMAIN_WHITE_LIST = ['alibaba-inc.com'];

/*
 * 通过mtop获取数据
 * @param  {String} token         [token]
 * @param  {Object} env           [Env对象]
 * @param  {String} prefix        [mtop前缀]
 * @param  {String} api           [mtop方法名]
 * @param  {Object} data          [mtop对象]
 * @param  {Object} opt           [mtop可选参数]
 * @return {Object}               [Promise对象]
 * */
var mtopFetch = exports.mtopFetch = function mtopFetch(_ref) {
  var token = _ref.token,
      env = _ref.env,
      prefix = _ref.prefix;

  // param check
  if (!env) {
    throw new Error('param error, env: ' + env);
  }
  if (typeof env.isDevOrDaily !== "function" || typeof env.isProd !== "function" || typeof env.isPre !== "function") {
    throw new Error('env object error');
  }
  // prefix设置
  if (env.isProd()) {
    lib.mtop.config.prefix = 'h5api';
    lib.mtop.config.subDomain = 'm';
    var mainDomain = location.hostname.split('.').slice(-2).join('.');
    lib.mtop.config.mainDomain = DOMAIN_WHITE_LIST.some(function (domain) {
      return domain === mainDomain;
    }) ? 'taobao.com' : mainDomain;
  } else if (env.isPre()) {
    lib.mtop.config.prefix = 'h5api';
    lib.mtop.config.subDomain = 'wapa';
    lib.mtop.config.mainDomain = 'taobao.com';
  } else {
    lib.mtop.config.subDomain = 'waptest';
    lib.mtop.config.mainDomain = 'taobao.com';
  }
  // 拦截器
  var _injection = {};
  return {
    request: function request(api, data) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$v = _ref2.v,
          v = _ref2$v === undefined ? '1.0' : _ref2$v,
          _ref2$ecode = _ref2.ecode,
          ecode = _ref2$ecode === undefined ? 0 : _ref2$ecode,
          _ref2$timeout = _ref2.timeout,
          timeout = _ref2$timeout === undefined ? 20000 : _ref2$timeout;

      for (var i in data) {
        if (_typeof(data[i]) === 'object' && data.hasOwnProperty(i)) {
          data[i] = JSON.stringify(data[i]);
        }
      }
      return new Promise(function (resolve, reject) {
        var token = void 0,
            ext = {};
        if (_injection.token && typeof _injection.token === 'function') {
          token = _injection.token();
        } else if (_injection.token && typeof _injection.token === 'string') {
          token = _injection.token;
        }
        // 添加额外必传参数
        if (_injection.ext && _typeof(_injection.ext) === 'object') {
          ext = Object.assign({}, _injection.ext);
        }
        lib.mtop.request({
          api: '' + (prefix ? prefix + '.' : '') + api,
          v: v,
          data: _extends({ token: token }, data, ext),
          ecode: ecode,
          type: env.isDevOrDaily() ? 'GET' : 'POST',
          dataType: env.isDevOrDaily() ? 'originaljsonp' : 'json',
          timeout: timeout
        }).then(function (response) {
          if (validateMtopResponse(response.data)) {
            // intercept if needed
            if (_injection.success) {
              _injection.success(response.data.value);
            }
            return resolve(response.data.value);
          }
          var res = {
            code: response.data && response.data.code,
            msg: response.data && response.data.message && response.data.message.cust,
            dev: response.data && response.data.message && response.data.message.dev
          };
          // intercept if needed
          if (_injection.failure) {
            _injection.failure(res);
          }
          return reject(res);
        }, function (error) {
          var res = {
            code: -1,
            msg: error && error.ret && error.ret[0].split('::')[1]
          };
          // intercept if needed
          if (_injection.failure) {
            _injection.failure(res);
          }
          return reject(res);
        });
      });
    },
    inject: function inject(injection) {
      Object.assign(_injection, injection);
    }
  };
};

exports.default = mtopFetch;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_alipic-utils@0.0.2@@ali/alipic-utils/lib/mtopFetch.js
// module id = 265
// module chunks = 6